import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlService } from '../../services/UrlService';

/**
 * Data layer for the external taxpayer questionnaire form (CU-868kg6qux).
 * Deliberately does NOT extend TaxplanIQServices: there is no session and no
 * Bearer token — the opaque recipient token in the path is the only credential.
 * The request interceptor treats `questionnaire-form` as public, so it neither
 * attaches a JWT nor bounces the taxpayer on a 401.
 */
@Injectable({ providedIn: 'root' })
export class PublicQuestionnaireService {

  private base = `${UrlService.getBaseUrl('JAVA')}/TaxPlanningServices/questionnaire-form`;
  private jsonHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  bootstrap(token: string): Observable<any> {
    return this.http.get(`${this.base}/${token}`);
  }

  getQuestions(token: string, bucket = ''): Observable<any> {
    return this.http.get(`${this.base}/${token}/questions?bucket=${encodeURIComponent(bucket)}`);
  }

  getSectionQuestions(token: string, sectionId: string, bucket = ''): Observable<any> {
    return this.http.get(
      `${this.base}/${token}/sections/${sectionId}/questions?bucket=${encodeURIComponent(bucket)}`);
  }

  saveAnswers(token: string, payload: any): Observable<any> {
    return this.http.post(`${this.base}/${token}/answers`, JSON.stringify(payload), { headers: this.jsonHeaders });
  }

  submitAnswers(token: string, payload: any): Observable<any> {
    return this.http.post(
      `${this.base}/${token}/answers/submit`, JSON.stringify(payload), { headers: this.jsonHeaders });
  }

  /** Multipart upload URL for the file input; the token authorizes it. */
  uploadUrl(token: string, questionId: string, bucket = ''): string {
    return `${this.base}/${token}/questions/${questionId}/documents?bucket=${encodeURIComponent(bucket)}`;
  }

  deleteDocument(token: string, questionId: string, documentId: string): Observable<any> {
    return this.http.delete(`${this.base}/${token}/questions/${questionId}/documents/${documentId}`);
  }

  documentUrl(token: string, documentId: string): Observable<any> {
    return this.http.get(`${this.base}/${token}/documents/${documentId}`);
  }
}
